module.exports = __webpack_public_path__ + "static/media/md-gift.de8beff1.svg";